export const LISTE_SECTEUR = {
  breadcrumb: {
    parametrage: 'Paramétrage',
    liste: 'Liste de secteurs',
  },
  title: 'Liste de secteurs',
  titlePage: 'Liste des secteurs',
  actions: {
    add: 'Ajouter un secteur',
    secteurArchive: 'Afficher les secteurs archivés ({nbre})',
    masquerSecteurArchiver: 'Masquer les secteurs archivés ({nbre})',
  },
  tab: {
    libelle: 'Libellé',
    type: 'Type',
  },
  popUp: {
    titleArchiver: 'Êtes-vous sûr de vouloir archiver ce secteur ?',
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver ce secteur ?',
    titleSupprimer: 'Êtes-vous sûr de vouloir supprimer ce secteur ?',
  },
  messages: {
    success: {
      archiver: 'Le secteur a été archivé',
      desarchiver: 'Le secteur a été désarchivé',
      supprimer: 'Le secteur a été supprimé',
    },
  },
};
export const EDITION_SECTEUR = {
  breadcrumb: {
    parametrage: 'Paramétrage',
    edition: 'Edition secteur',
  },
  titleEdit: 'Edition Secteur',
  titleAdd: 'Ajouter un secteur',
  type: {
    commercial: 'Commercial',
    patrimoine: 'Patrimoine',
  },
  information: {
    libelle: 'Libellé',
    type: 'Type de Secteur',
  },
  error: {
    type: 'Type de secteur',
  },
  success: {
    add: 'Le secteur a été ajouté',
    edit: 'Le secteur a été modifié',
  },
  validations: {
    secteurLinked: 'Vous ne pouvez supprimer un secteur qui est utilisé',
  },
};

export const SECTEUR_LIEN = {
  addPopUp: {
    title: 'Sélection d\'un secteur',
    titleAddSecteurForElements: 'Ajouter les éléments a un secteur',
    titleDeleteSecteurForElements: 'Retirer les éléments du secteur',
    secteurTypes: 'Types de secteur',
    secteur: 'Secteur',
  },
  validation: {
    noSecteurMatch: 'Le secteur ne correspond pas au secteur de l\'utilisateur',
    noSecteur: 'Le secteur est obligatoire',
  },
  actions: {
    addSecteur: 'Ajouter à un secteur',
    deleteSecteur: 'Supprimer d\'un secteur',
  },
  success: {
    secteurIsAddOnElementsSelected: 'Les éléments selectionnés ont été ajoutés au secteur',
    secteurIsDeleteOnElementsSelected: 'Les éléments selectionnés ont été retiré du secteur',
  },
  translator: {
    secteur: 'Secteur',
    produits: 'Produits sélectionnés',
    dispositifs: 'Dispositifs sélectionnés',
    baux: 'Baux sélectionnés',
  },
  warning: {
    secteursArchives: 'Les secteurs en orange sont actuellement archivés',
  },
  textInfo: 'Tous les secteurs existants seront écrasés',
};
